import { ASSISTANT_SETTINGS_TAB_FIELDS, BOOLEAN_SETTINGS_FIELDS } from "src/pages/admin/GeneralSettingsConsts";

// Text fields fall back to "" so MUI keeps them controlled; booleans must not, or false becomes "".
export const getFieldValue = (field, settingsData) =>
  (BOOLEAN_SETTINGS_FIELDS.has(field)
    ? (settingsData?.[field] ?? false)
    : (settingsData?.[field] || ""));

export const FORMATTING_HANDLERS = {
  [ASSISTANT_SETTINGS_TAB_FIELDS.skillsDashboards]: (value) => {
    const normalizedValue = Array.isArray(value) && value.length > 0 && typeof value[0] === "object"
      ? value.map(item => item.display_key || item.key)
      : value;
    return normalizedValue;
  }
};
